import {
	ReactElement,
	RefObject,
	useRef,
	useState
} from "react";
import { Icon, IconValue } from "../../Icon/Icon";
import { Button } from "./Button/Button";
import { ensureNotNil } from "client/Misc/utils";

export type ButtonPopupControlRenderPopupArgs = {
	target: HTMLButtonElement;
	onClose: () => void;
};

export type ButtonPopupControlProps = {
	icon: IconValue;
	trackingId: string;
	isDisabled?: boolean;
	tooltip: string;
	children: (args: ButtonPopupControlRenderPopupArgs) => ReactElement;
};

export const ButtonPopupControl = (props: ButtonPopupControlProps): ReactElement => {
	const {
		icon,
		trackingId,
		isDisabled = false,
		tooltip,
		children
	} = props;

	const [isOpen, setIsOpen] = useState<boolean>(false);
	const buttonRef: RefObject<HTMLButtonElement | null> = useRef<HTMLButtonElement>(null);

	return (
		<>
			<Button
				onClick={(): void => setIsOpen(true)}
				isActive={isOpen}
				ref={buttonRef}
				handleOn="click"
				trackingId={trackingId}
				isDisabled={isDisabled}
				tooltip={tooltip}
			>
				<Icon value={icon} />
			</Button>
			{isOpen && children({
				target: ensureNotNil(buttonRef.current),
				onClose: (): void => setIsOpen(false)
			})}
		</>
	);
};
ButtonPopupControl.displayName = "ButtonPopupControl";
